module.exports = __webpack_public_path__ + "img/problem_feedback.8deb640a.svg";